import store from '../redux/store';

export default function isMaxLoginAttemptsExceeded() {
  const { isMaxAttemptsExceeded } = store.getState().auth;
  return isMaxAttemptsExceeded;
}
